'use client';

import { useEffect, useRef, useState } from 'react';

import { staticMediaUrl } from '@/fo/util/image-loader';

import { ArrowDown } from '../ArrowDown/ArrowDown';

import { styles } from './HeroBanner.styles';

export function HeroBanner() {
  const slots = styles();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isSecond, setIsSecond] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;

    let raf = 0;
    const handleScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        const viewportHeight = window.innerHeight || 1;
        const sectionStart = node.offsetTop;
        const sectionScrollable = Math.max(
          1,
          node.offsetHeight - viewportHeight
        );
        const y = window.scrollY;
        const progressRaw = (y - sectionStart) / sectionScrollable;
        const progress = Math.min(1, Math.max(0, progressRaw));
        setIsSecond(progress > 0.5);
      });
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    return () => {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('scroll', handleScroll as EventListener);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={slots.base()}
    >
      <div className={slots.screen()}>
        <video
          className={slots.bg()}
          autoPlay
          muted
          playsInline
          loop
          preload="metadata"
        >
          <source
            src={staticMediaUrl('landing/ie_intensive_nad/nad-video-mob.mp4')}
            media="(max-width: 1023px)"
          />
          <source
            src={staticMediaUrl('landing/ie_intensive_nad/nad-video.mp4')}
            media="(min-width: 1024px)"
          />
        </video>
        <div className={slots.content()}>
          <div
            className={`${slots.textWrapper()} ${
              isSecond
                ? 'pointer-events-none !m-0 h-0 -translate-y-8 overflow-hidden opacity-0 md:pointer-events-auto md:!m-[revert] md:h-auto md:translate-y-0 md:overflow-visible md:opacity-100'
                : 'z-10 translate-y-0'
            }`}
          >
            <p className={slots.infoTextMobile()}>Инновация</p>
            <p className={slots.text()}>
              Что, если бы вы <br className="hidden lg:block" />
              могли восстановить{' '}
              <span className={slots.italic()}>качество вашей кожи</span>{' '}
              изнутри?
            </p>
          </div>
          <h1
            className={`${slots.title()} ${
              isSecond
                ? 'pointer-events-none !m-0 h-0 -translate-y-8 overflow-hidden opacity-0 md:pointer-events-auto md:!m-[revert] md:h-auto md:translate-y-0 md:overflow-visible md:opacity-100'
                : 'z-10 translate-y-0'
            }`}
          >
            INTENSIVE <span className={slots.semibold()}>NAD+</span>
            <br />
            <span className={slots.semibold()}>с ниацинамидом</span>
          </h1>
          <div
            className={`${slots.info()} ${
              isSecond
                ? 'z-10 translate-y-0'
                : 'pointer-events-none !m-0 h-0 translate-y-8 overflow-hidden opacity-0 md:pointer-events-auto md:!m-[revert] md:h-auto md:translate-y-0 md:overflow-visible md:opacity-100'
            }`}
          >
            <p className={slots.infoText()}>Инновация</p>
            <p className={slots.infoNumber()}>
              <span className={slots.small()}>+</span>
              <span className={slots.number()}>82</span>
              <span className={slots.small()}>%</span>
            </p>
            <p className={slots.infoDescription()}>
              улучшается качество кожи<sup>1</sup>
            </p>
          </div>
        </div>
        <ArrowDown
          className={slots.arrowDown()}
          targetId="technology"
        />
      </div>
    </div>
  );
}
